import { LocationStore } from "@/types/store";
import { create } from "zustand";

const useLocationStore = create<LocationStore>((set) => ({
  userLatitude: null,
  userLongitude: null,
  userAddress: null,
  userCity: null,
  destinationLatitude: null,
  destinationLongitude: null,
  destinationAddress: null,
  destinationCity: null,
  destinationCoordinates: null,
  setUserLocation: (latitude, longitude) =>
    set({
      userLatitude: latitude,
      userLongitude: longitude,
    }),
  setDestinationLocation: (latitude, longitude) =>
    set({
      destinationLatitude: latitude,
      destinationLongitude: longitude,
      destinationCoordinates:
        latitude !== null && longitude !== null
          ? { latitude, longitude }
          : null,
    }),
}));

export default useLocationStore;
